import React, { memo } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import bemit from 'Functions/bemit';
export default memo(function BookingContainer({
  ...props
}) {
  const state = BookingFormStore.useState(function (store) {
    return {
      step: store.step,
      reservation_source: store.reservation_source
    };
  });
  const modifiers = [];
  if (state.reservation_source === 'offline') {
    modifiers.push('offline');
  }
  if (props['white-label-booking'] && state.step === 0) {
    modifiers.push('white-label-booking');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: bemit('c-front-booking', modifiers)
  }, props.children);
});
